import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Button, Paper } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import CardHeader from '@material-ui/core/CardHeader';
import { CommonConfig } from '../../config/common-config';
import LoaderPopUp from '../../components/loaderpopup/loader';
import SuccessPopUp from '../../components/loaderpopup/success';
import ErrorPopUp from '../../components/loaderpopup/error';
import Cardboxes from './Card';
import './styles.css';
import { createGenInfoRequestSubmit } from '../checkListGenerator/store/actions/index';
import { setSelectedStageId } from '../services/store/actions';
import { userType } from '../../config/usertypeValue';
import Typography from '@material-ui/core/Typography';
import TabList from '../../components/checklistTab/tabList';
import buttonDisable from '../../components/disableField/buttonDisable';

const useStyles = makeStyles({
    cardCustom: {
        padding: '0',
        background: '#fcfcfc',
        borderBottom: '1px solid #f1f1f',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: '17px',
        fontWeight: 'bold',
        color: '#000000',
    },
    title1: {
        fontSize: '19px',
        fontWeight: 'bold',
        color: '#000000',
    },
    pos: {
        marginBottom: 12,
    },
    textArea: {
        width: '100%',
        fontSize: '15px',
        border: 'none',
        borderBottom: '2px solid #dddddd',
        resize: 'none',
        marginTop: '26px',
    },
    btn: {
        width: '100%',
        textTransform: 'capitalize',
    },
    footerBtn: {
        background: '#4e4cac',
        color: '#FFFFFF',
        width: '180px',
        textTransform: 'capitalize',
        '&:hover': {
            background: '#4e4cac',
        },
    },
    heading: {
        marginBottom: '25px',
        justifyContent: 'space-between',
    },
    statement: {
        margin: '15px',
        fontSize: 'inherit',
        color: 'grey',
        fontFamily: 'Rubik !important',
    },
});

const DetailAnalysisCore = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch({});
    const [showLoader, setShowLoader] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [submitpop, setSubmitpop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [toggleTrue, setToggleTrue] = useState();
    const [uploadedFiles, setUploadedFiles] = useState(true);
    const [updateValuesfromChild, setUpdateValuesfromChild] = useState('');
    const [checklist, setChecklist] = useState('');
    const checklistValues = checklist.checklistJson;
    const checklist1 = checklistValues && checklistValues.checklistL1;
    const checklist1que = checklist1 && checklist1.questions;
    const statusID = checklist && checklist.currentStage && checklist.currentStage.id;
    // const [statusID, setStatusId] = useState('');
    const [statusFlag, setStatusFlag] = useState(true);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const stageId = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    console.log('location', location.state);
    const [draftFlag, setDraftFlag] = useState(true);
    const [attachmentFlag, setAttachmentFlag] = useState(true);

    const [data, setData] = useState([
        {
            questionId: 1,
            questionText: 'Bank Analysis',
            isAttachmentRequired: true,
            attachmentsByCoreteam: [],
            remarkByCoreteam: '',
            attachmentsByItecteam: [],
            remarkByItecteam: [],
            remarkByItecAM: [],
            response: null,
            stage: 'Detailed Analysis',
            autoPopulate: true,
            editable: false,
            toggle: location && location.state && location.state.flag === false ? false : true,
        },
        {
            questionId: 2,
            questionText: 'Bank credit analysis only',
            isAttachmentRequired: true,
            attachmentsByCoreteam: [],
            remarkByCoreteam: '',
            attachmentsByItecteam: [],
            remarkByItecteam: [],
            remarkByItecAM: [],
            response: null,
            stage: 'Detailed Analysis',
            autoPopulate: true,
            editable: false,
            toggle: false,
        },
        {
            questionId: 3,
            questionText: 'Detailed accounting',
            isAttachmentRequired: true,
            attachmentsByCoreteam: [],
            remarkByCoreteam: '',
            attachmentsByItecteam: [],
            remarkByItecteam: [],
            remarkByItecAM: [],
            response: null,
            stage: 'Detailed Analysis',
            autoPopulate: true,
            editable: false,
            toggle: false,
        },
    ]);
    const [dataList, setDataList] = useState([
        {
            questionId: 1,
            questionText: 'Bank Analysis',
            isAttachmentRequired: true,
            attachmentsByCoreteam: [],
            remarkByCoreteam: '',
            attachmentsByItecteam: [],
            remarkByItecteam: [],
            remarkByItecAM: [],
            response: null,
            stage: 'Detailed Analysis',
            autoPopulate: true,
            editable: false,
            toggle: false,
        },
        {
            questionId: 2,
            questionText: 'Bank credit analysis only',
            isAttachmentRequired: true,
            attachmentsByCoreteam: [],
            remarkByCoreteam: '',
            attachmentsByItecteam: [],
            remarkByItecteam: [],
            remarkByItecAM: [],
            response: null,
            stage: 'Detailed Analysis',
            autoPopulate: true,
            editable: false,
            toggle: false,
        },
        {
            questionId: 3,
            questionText: 'Detailed accounting',
            isAttachmentRequired: true,
            attachmentsByCoreteam: [],
            remarkByCoreteam: '',
            attachmentsByItecteam: [],
            remarkByItecteam: [],
            remarkByItecAM: [],
            response: null,
            stage: 'Detailed Analysis',
            autoPopulate: true,
            editable: false,
            toggle: false,
        },
    ]);
    const serviceIdSelected = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName.tennantName);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const tennantname = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantnameValue = tennantname && tennantname.tennantName;
    const servicesID = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const dbname = tennantname && tennantname.tennantName;
    const tennantName = tennantnameValue && tennantnameValue.toUpperCase();

    useEffect(() => {
        // if (statusFlag) {
        let isPresent = data.some((ele) => ele.toggle);
        // console.log('present', isPresent)
        if (location && location.state && location.state.flag === false && !isPresent) {
            setDraftFlag(true);
            setUploadedFiles(false);
            // console.log('tttttttt')
        }

        axios
            .get(
                `${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${
                tennantnameValue === 'Advith' ? tennantnameValue : imcNameSelected
                }/${serviceIdValue}`,
                {
                    headers: {
                        Authorization: bearerToken,
                    },
                }
            )
            .then((response) => {
                if (response && response.data) {
                    setChecklist(response.data);
                }
            })
            .catch((error) => { });
        if (userType.statusFlag) {
            //console.log('userType.statusFlag', userType.statusFlag)
            getInitialStage();
        }
        //console.log('data', data)
        // forceUpdateComponent();
        // }
        // userType.value = '';
        axios
            .get(
                `${CommonConfig.dev.baseUrl1}/api/itr/itrhistory-by-serviceIdandstageId/${
                tennantName === 'ADVITH' ? tennantnameValue : imcNameSelected
                }/${serviceIdValue}/11`,
                {
                    headers: {
                        Authorization: bearerToken,
                    },
                }
            )
            .then((response) => {
                // console.log('aaaaa', response)
                if (response && response.data) {
                    userType.detailAnalysisFlag = false;
                } else {
                    userType.detailAnalysisFlag = true;
                }
            })
            .catch((error) => { });
        // console.log('location.state.flag', data)
    }, [props, bearerToken, statusID, tennantnameValue, data]);

    // const [serviceIdSelected1, setserviceIdSelected1] = useState(serviceIdSelected);

    const payload = location.state && location.state.payload ? location.state.payload : '';
    let filesname = [];

    const deleteCard = (id) => {
        var myArray = data.filter(function (obj) {
            return obj.questionId !== id;
        });
        setData(myArray);
        setUploadedFiles(false);
        setDraftFlag(true);
        myArray.filter((ele, i) => {
            if (ele.toggle) {
                setUploadedFiles(true);
                setDraftFlag(false);
            }
        });
    };

    const addCard = () => {
        setData([
            ...data,
            {
                questionId: data.length + 1,
                questionText: '',
                isAttachmentRequired: true,
                attachmentsByCoreteam: [],
                remarkByCoreteam: '',
                attachmentsByItecteam: [],
                remarkByItecteam: [],
                remarkByItecAM: [],
                response: null,
                stage: 'Detailed Analysis',
                autoPopulate: true,
                editable: true,
                toggle: true,
            },
        ]);
        setUploadedFiles(true);
        // alert("Card Added at end")
    };

    const setTitle = (event, id) => {
        var myArray = data.filter(function (obj) {
            if (obj.questionId == id && obj.editable) {
                obj.questionText = event.target.value;
                return obj;
            } else return obj;
        });
        setData(myArray);
    };

    const setRemarks = (event, id) => {
        var myArray = data.filter(function (obj) {
            if (obj.questionId == id) {
                obj.remarkByCoreteam = event.target.value;
                return obj;
            } else return obj;
        });
        setData(myArray);
    };

    const toggle = (id) => {
        var myArray = data.filter(function (obj) {
            if (obj.questionId == id) {
                obj.toggle = !obj.toggle;
                return obj;
            } else return obj;
        });
        setData(myArray);
        setUploadedFiles(false);
        setDraftFlag(true);
        let isAttachmentFlag = myArray.some((ele) => ele.attachmentsByCoreteam && ele.attachmentsByCoreteam.length && ele.toggle);
        // console.log('isAttachmentFlag', isAttachmentFlag)
        if (isAttachmentFlag) {
            setAttachmentFlag(false);
        } else {
            setAttachmentFlag(true);
        }
        myArray.filter((ele, i) => {
            // setUploadedFiles
            if (ele.toggle) {
                // console.log('disable');
                setUploadedFiles(true);
                setDraftFlag(false);
            }
        });
    };

    const handleRemoveClick = (index, id) => {
        data.map((ele, i) => {
            if (ele.questionId === id) {
                return ele.attachmentsByCoreteam.splice(index, 1);
            }
        });
        setData(data);
        // console.log('data', data)
        let isAttachmentFlag = data.some((ele) => ele.attachmentsByCoreteam && ele.attachmentsByCoreteam.length);
        // console.log('isAttachmentFlag', isAttachmentFlag)
        if (!isAttachmentFlag) {
            setToggleTrue(false);
        }
    };

    const saveFile = (questionId, event) => {
        // console.log('event', event)
        // attachmentsByCoreteam
        let files = event;
        for (let i = 0; i < files.length; i++) {
            const dataFile = new FormData();
            dataFile.append('file', files[i]);
            axios
                .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${tennantnameValue}/${serviceIdSelected}/myimage`, dataFile, {
                    headers: {
                        Authorization: bearerToken,
                    },
                })
                .then((response) => {
                    filesname.push(response.data);
                    setToggleTrue(true);
                    const newArray = data.map((row) => {
                        if (row.questionId === questionId) {
                            row.attachmentsByCoreteam.push(filesname[0]);
                            setAttachmentFlag(false);
                        }
                        return row;
                    });
                    // console.log('newArray', newArray);
                    setData(newArray);
                });
        }
    };

    const handleClose = () => {
        setShowLoader(false);
        setSuccessPop(false);
        setErrorPop(false);
    };
    const submit = () => {
        setShowLoader(true);
        var myArray = data.filter(function (obj) {
            if (obj.toggle) {
                return obj;
            }
            if (obj.remarkByCoreteam) {
                return (obj.remarkByCoreteam = [obj.remarkByCoreteam]);
            }
        });
        // console.log('myArray',myArray)
        // // var tempArray = myArray.filter(function (obj) {
        // //     if(obj.remarkByCoreteam){
        // //         return obj.remarkByCoreteam = [obj.remarkByCoreteam];
        // //     }
        // // });
        myArray.map(function (obj) {
            if (obj.remarkByCoreteam) {
                return (obj.remarkByCoreteam = [obj.remarkByCoreteam]);
            } else {
                return (obj.remarkByCoreteam = []);
            }
        });
        // console.log('myArray', myArray);

        const questionData = JSON.stringify({
            serviceId: serviceIdSelected,
            detailedAnalysisJson: {
                detailedAnalysis: [...myArray],
                additionalQuestion: [],
                assigedUsers: [],
            },
        });
        const axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                Authorization: bearerToken,
            },
        };
        axios
            .post(`${CommonConfig.dev.baseUrl1}/api/itr/detailed-analysis/create/${tennantDetails}`, questionData, axiosConfig)
            .then((response) => {
                //console.log(response.status);

                if (response.status === 200) {
                    setTimeout(() => {
                        setShowLoader(false);
                        setSubmitpop(true);
                    }, 1500);
                    setTimeout(() => {
                        history.push('/menu/openservice');
                    }, 3000);
                    //console.log(response.status);
                }

                handleClose();
            })
            .catch((error) => {
                // console.error('There was an error!', error.response.data);
                const errResult = error.response;
                if (errResult.data) {
                    setTimeout(() => {
                        setShowLoader(false);
                        setErrorPop(true);
                    }, 1500);
                    setTimeout(() => {
                        setErrorPop(false);
                    }, 5000);
                    setErrorMsgGenerateRecceipt(errResult.data.message);
                }
            });
    };

    const handleSubmitClickFordraftdoc = () => {
        setShowLoader(true);
        dispatch(
            createGenInfoRequestSubmit({
                params: payload,
                bearerToken,
                serviceIdValue: servicesID,
                usertype,
                tennantnameValue: dbname,
                statusIDValue: 16,
            })
        );
        dispatch(setSelectedStageId(16));
        userType.value = 'Draft Statements';
        setTimeout(() => {
            setShowLoader(false);
            // usertype.detailAnalysisFlag = true;
            history.push({
                pathname: '/menu/imc-draft-document',
                state: { payload },
            });
        }, 1500);
    };

    const getInitialStage = () => {
        if (statusID === 2 && usertype === 'Ultimate Client') {
            userType.value = 'L1 Checklist';
            navigateChecklist('/menu/checkListUltimate', 'L1 Checklist');
        }
        if (statusID === 4 && usertype === 'ITeC Team') {
            userType.value = 'L1 CRC Confirmed';
            navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed');
        }
        if (statusID === 5 && usertype === 'ITeC AM and above') {
            userType.value = 'L1 AM Confirmed';
            navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed');
        }
        if (statusID === 6 && usertype === 'Ultimate Client') {
            userType.value = 'L2 Checklist';
            navigateChecklist('/menu/checkListUltimate', 'L2 Checklist');
        }
        if (statusID === 8 && usertype === 'ITeC Team') {
            userType.value = 'L2 CRC Confirmed';
            navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed');
        }
        if (statusID === 10 && (usertype === 'EM' || usertype === 'Other employee users')) {
            console.log('bbbbbb');
            userType.value = 'EM Confirmed';
            navigateChecklist('/menu/crc-checklist', 'EM Confirmed');
        }
        if (statusID === 12 && usertype === 'ITeC Team') {
            userType.value = 'Detailed Analysis';
            navigateChecklist('itec-detail-analysis-crc', 'Detailed Analysis');
        }
        if (statusID === 15 && usertype === 'ITeC AM and above') {
            userType.value = 'Detailed Analysis';
            navigateChecklist('/menu/itec-detail-analysis-am', 'Detailed Analysis');
        }
        if (statusID === 14 && (usertype === 'EM' || usertype === 'Other employee users')) {
            userType.value = 'Detailed Analysis';
            navigateChecklist('/menu/detail-analysis', 'Detailed Analysis');
        }
        if (statusID === 13 && usertype === 'Other employee users') {
            userType.value = 'Detailed Analysis';
            navigateChecklist('/menu/detail-analysis', 'Detailed Analysis');
        }
        if ((statusID === 16 || statusID === 18) && usertype === 'EM') {
            userType.value = 'Draft Statements';
            navigateChecklist('/menu/imc-draft-document', 'Draft Statements');
        }
        if (statusID === 17 && usertype === 'Ultimate Client') {
            userType.value = 'Draft Statements';
            navigateChecklist('/menu/client-draft-document', 'Draft Statements');
        }
        if (statusID === 19 && (usertype === 'EM' || usertype === 'Other employee users')) {
            userType.value = 'Tax Payment and Filing';
            navigateChecklist('/menu/imc-tax-payment', 'Final Statement');
        }
        if (statusID === 20 && usertype === 'Ultimate Client') {
            userType.value = 'Tax Payment and Filing';
            navigateChecklist('/menu/client-tax-payment', 'Tax Payment and Filing');
        }
        if (statusID === 21 && (usertype === 'EM' || usertype === 'Other employee users')) {
            userType.value = 'Tax Payment and Filing';
            navigateChecklist('/menu/imc-final-doc-approval', 'Tax Payment and Filing');
        }
        if (statusID === 22 && (usertype === 'EM' || usertype === 'Other employee users')) {
            userType.value = 'Reports';
            navigateChecklist('/menu/imc-reports', 'Reports');
        }
        // if (statusID === 10 && usertype === 'EM') {
        //     userType.value = 'EM Confirmed';
        // }
    };

    const navigateChecklist = (path, typeValue) => {
        console.log('aaaaa', path, typeValue, statusID, stageId);
        if (typeValue === 'L1 Checklist') {
            userType.historyStageId = 3;
        }
        if (typeValue === 'L1 CRC Confirmed') {
            userType.historyStageId = 5;
        }
        if (typeValue === 'L1 AM Confirmed') {
            userType.historyStageId = userType.checklistFlag ? 5 : 6;
        }
        if (typeValue === 'L2 Checklist') {
            userType.historyStageId = 7;
        }
        if (typeValue === 'L2 CRC Confirmed') {
            userType.historyStageId = 10;
        }
        if (typeValue === 'EM Confirmed') {
            userType.historyStageId = 10;
        }
        userType.statusFlag = false;
        userType.value = typeValue;
        history.push({
            pathname: path,
            state: { path: 'openservices' },
        });
    };

    return (
        <>
            {showLoader ? <LoaderPopUp showLoader={showLoader} handleClose={handleClose} /> : null}
            {/* <TabList /> */}
            <Grid>
                <div>
                    <div className="stage-indicator">
                        <ul>
                            {statusID === 2 && usertype === 'Ultimate Client' ? (
                                <ul>
                                    <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className="activetab">
                                        L1 Checklist
                                    </li>
                                </ul>
                            ) : (
                                    ''
                                )}
                            {statusID === 4 && usertype === 'ITeC Team' ? (
                                <ul>
                                    <li
                                        onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}
                                        className={userType.value === 'L1 Checklist' ? 'active' : ''}
                                    >
                                        L1 Checklist
                                    </li>
                                    <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className="activetab">
                                        L1 CRC Confirmed
                                    </li>
                                </ul>
                            ) : (
                                    ''
                                )}
                            {statusID === 5 && usertype === 'ITeC AM and above' ? (
                                <ul>
                                    <li
                                        onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}
                                        className={userType.value === 'L1 Checklist' ? 'active' : ''}
                                    >
                                        L1 Checklist
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')}
                                        className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}
                                    >
                                        L1 CRC Confirmed
                                    </li>
                                    <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className="activetab">
                                        L1 AM Confirmed
                                    </li>
                                </ul>
                            ) : (
                                    ''
                                )}
                            {statusID === 6 && usertype === 'Ultimate Client' ? (
                                <ul>
                                    <li
                                        onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}
                                        className={userType.value === 'L1 Checklist' ? 'active' : ''}
                                    >
                                        L1 Checklist
                                    </li>
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li> */}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li> */}
                                    <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className="activetab">
                                        L2 Checklist
                                    </li>
                                </ul>
                            ) : (
                                    ''
                                )}
                            {statusID === 8 && usertype === 'ITeC Team' ? (
                                <ul>
                                    <li
                                        onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}
                                        className={userType.value === 'L1 Checklist' ? 'active' : ''}
                                    >
                                        L1 Checklist
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')}
                                        className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}
                                    >
                                        L1 CRC Confirmed
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')}
                                        className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}
                                    >
                                        L1 AM Confirmed
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')}
                                        className={userType.value === 'L2 Checklist' ? 'active' : ''}
                                    >
                                        L2 Checklist
                                    </li>
                                    <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className="activetab">
                                        L2 CRC Confirmed
                                    </li>
                                </ul>
                            ) : (
                                    ''
                                )}
                            {statusID === 10 && (usertype === 'EM' || usertype === 'Other employee users') ? (
                                <ul>
                                    <li
                                        onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}
                                        className={userType.value === 'L1 Checklist' ? 'active' : ''}
                                    >
                                        L1 Checklist
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')}
                                        className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}
                                    >
                                        L1 CRC Confirmed
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')}
                                        className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}
                                    >
                                        L1 AM Confirmed
                                    </li>
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')}
                                            className={userType.value === 'L2 Checklist' ? 'active' : ''}
                                        >
                                            L2 Checklist
                                        </li>
                                    ) : null}
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')}
                                            className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}
                                        >
                                            L2 CRC Confirmed
                                        </li>
                                    ) : null}
                                    {/* <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')}
                                        className={userType.value === 'EM Confirmed' ? 'active' : ''}
                                    >
                                        EM Confirmed
                                    </li> */}
                                    <li
                                        onClick={() => navigateChecklist('/menu/detailAnalysisCore', 'Detailed Analysis')}
                                        className="activetab"
                                    >
                                        Detailed Analysis
                                    </li>
                                </ul>
                            ) : (
                                    ''
                                )}
                            {statusID === 12 && usertype === 'ITeC Team' ? (
                                <ul>
                                    <li
                                        onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}
                                        className={userType.value === 'L1 Checklist' ? 'active' : ''}
                                    >
                                        L1 Checklist
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')}
                                        className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}
                                    >
                                        L1 CRC Confirmed
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')}
                                        className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}
                                    >
                                        L1 AM Confirmed
                                    </li>
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')}
                                            className={userType.value === 'L2 Checklist' ? 'active' : ''}
                                        >
                                            L2 Checklist
                                        </li>
                                    ) : null}
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')}
                                            className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}
                                        >
                                            L2 CRC Confirmed
                                        </li>
                                    ) : null}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                    <li
                                        onClick={() =>
                                            navigateChecklist(
                                                userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/itec-detail-analysis-crc',
                                                'Detailed Analysis'
                                            )
                                        }
                                        className="activetab"
                                    >
                                        Detailed Analysis
                                    </li>
                                </ul>
                            ) : (
                                    ''
                                )}
                            {statusID === 15 && usertype === 'ITeC AM and above' ? (
                                <ul>
                                    <li
                                        onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}
                                        className={userType.value === 'L1 Checklist' ? 'active' : ''}
                                    >
                                        L1 Checklist
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')}
                                        className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}
                                    >
                                        L1 CRC Confirmed
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')}
                                        className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}
                                    >
                                        L1 AM Confirmed
                                    </li>
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')}
                                            className={userType.value === 'L2 Checklist' ? 'active' : ''}
                                        >
                                            L2 Checklist
                                        </li>
                                    ) : null}
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')}
                                            className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}
                                        >
                                            L2 CRC Confirmed
                                        </li>
                                    ) : null}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                    <li
                                        onClick={() =>
                                            navigateChecklist(
                                                userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/itec-detail-analysis-am',
                                                'Detailed Analysis'
                                            )
                                        }
                                        className="activetab"
                                    >
                                        Detailed Analysis
                                    </li>
                                </ul>
                            ) : (
                                    ''
                                )}
                            {statusID === 14 && (usertype === 'EM' || usertype === 'Other employee users') ? (
                                <ul>
                                    <li
                                        onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}
                                        className={userType.value === 'L1 Checklist' ? 'active' : ''}
                                    >
                                        L1 Checklist
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')}
                                        className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}
                                    >
                                        L1 CRC Confirmed
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')}
                                        className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}
                                    >
                                        L1 AM Confirmed
                                    </li>
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')}
                                            className={userType.value === 'L2 Checklist' ? 'active' : ''}
                                        >
                                            L2 Checklist
                                        </li>
                                    ) : null}
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')}
                                            className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}
                                        >
                                            L2 CRC Confirmed
                                        </li>
                                    ) : null}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                    <li
                                        onClick={() =>
                                            navigateChecklist(
                                                userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/detail-analysis',
                                                'Detailed Analysis'
                                            )
                                        }
                                        className="activetab"
                                    >
                                        Detailed Analysis
                                    </li>
                                </ul>
                            ) : (
                                    ''
                                )}
                            {statusID === 13 && usertype === 'Other employee users' ? (
                                <ul>
                                    <li
                                        onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}
                                        className={userType.value === 'L1 Checklist' ? 'active' : ''}
                                    >
                                        L1 Checklist
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')}
                                        className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}
                                    >
                                        L1 CRC Confirmed
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')}
                                        className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}
                                    >
                                        L1 AM Confirmed
                                    </li>
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')}
                                            className={userType.value === 'L2 Checklist' ? 'active' : ''}
                                        >
                                            L2 Checklist
                                        </li>
                                    ) : null}
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')}
                                            className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}
                                        >
                                            L2 CRC Confirmed
                                        </li>
                                    ) : null}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                    <li
                                        onClick={() =>
                                            navigateChecklist(
                                                userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/detail-analysis',
                                                'Detailed Analysis'
                                            )
                                        }
                                        className="activetab"
                                    >
                                        Detailed Analysis
                                    </li>
                                </ul>
                            ) : (
                                    ''
                                )}
                            {(statusID === 16 || statusID === 18) && (usertype === 'EM' || usertype === 'Other employee users') ? (
                                <ul>
                                    <li
                                        onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}
                                        className={userType.value === 'L1 Checklist' ? 'active' : ''}
                                    >
                                        L1 Checklist
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')}
                                        className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}
                                    >
                                        L1 CRC Confirmed
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')}
                                        className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}
                                    >
                                        L1 AM Confirmed
                                    </li>
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')}
                                            className={userType.value === 'L2 Checklist' ? 'active' : ''}
                                        >
                                            L2 Checklist
                                        </li>
                                    ) : null}
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')}
                                            className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}
                                        >
                                            L2 CRC Confirmed
                                        </li>
                                    ) : null}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                    <li
                                        onClick={() =>
                                            navigateChecklist(
                                                userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/detail-analysis',
                                                'Detailed Analysis'
                                            )
                                        }
                                        className={userType.value === 'Detailed Analysis' ? 'active' : ''}
                                    >
                                        Detailed Analysis
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/imc-draft-document', 'Draft Statements')}
                                        className="activetab"
                                    >
                                        Draft Statements
                                    </li>
                                </ul>
                            ) : (
                                    ''
                                )}
                            {statusID === 17 && usertype === 'Ultimate Client' ? (
                                <ul>
                                    <li
                                        onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}
                                        className={userType.value === 'L1 Checklist' ? 'active' : ''}
                                    >
                                        L1 Checklist
                                    </li>
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li> */}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li> */}
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')}
                                            className={userType.value === 'L2 Checklist' ? 'active' : ''}
                                        >
                                            L2 Checklist
                                        </li>
                                    ) : null}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> */}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                    {/* <li onClick={() => navigateChecklist('/menu/detail-analysis', 'Detailed Analysis')} className={userType.value === 'Detailed Analysis' ? 'active' : ''}>Detailed Analysis</li> */}
                                    <li
                                        onClick={() => navigateChecklist('/menu/client-draft-document', 'Draft Statements')}
                                        className="activetab"
                                    >
                                        Draft Statements
                                    </li>
                                </ul>
                            ) : (
                                    ''
                                )}
                            {statusID === 19 && (usertype === 'EM' || usertype === 'Other employee users') ? (
                                <ul>
                                    <li
                                        onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}
                                        className={userType.value === 'L1 Checklist' ? 'active' : ''}
                                    >
                                        L1 Checklist
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')}
                                        className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}
                                    >
                                        L1 CRC Confirmed
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')}
                                        className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}
                                    >
                                        L1 AM Confirmed
                                    </li>
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')}
                                            className={userType.value === 'L2 Checklist' ? 'active' : ''}
                                        >
                                            L2 Checklist
                                        </li>
                                    ) : null}
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')}
                                            className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}
                                        >
                                            L2 CRC Confirmed
                                        </li>
                                    ) : null}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                    <li
                                        onClick={() =>
                                            navigateChecklist(
                                                userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/detail-analysis',
                                                'Detailed Analysis'
                                            )
                                        }
                                        className={userType.value === 'Detailed Analysis' ? 'active' : ''}
                                    >
                                        Detailed Analysis
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/client-draft-document', 'Draft Statements')}
                                        className={userType.value === 'Draft Statements' ? 'active' : ''}
                                    >
                                        Draft Statements
                                    </li>
                                    <li onClick={() => navigateChecklist('/menu/imc-tax-payment', 'Final Statement')} className="activetab">
                                        Final Statement
                                    </li>
                                </ul>
                            ) : (
                                    ''
                                )}
                            {statusID === 20 && usertype === 'Ultimate Client' ? (
                                <ul>
                                    <li
                                        onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}
                                        className={userType.value === 'L1 Checklist' ? 'active' : ''}
                                    >
                                        L1 Checklist
                                    </li>
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li> */}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li> */}
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')}
                                            className={userType.value === 'L2 Checklist' ? 'active' : ''}
                                        >
                                            L2 Checklist
                                        </li>
                                    ) : null}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> */}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                    {/* <li onClick={() => navigateChecklist('/menu/detail-analysis', 'Detailed Analysis')} className={userType.value === 'Detailed Analysis' ? 'active' : ''}>Detailed Analysis</li> */}
                                    <li
                                        onClick={() => navigateChecklist('/menu/client-draft-document', 'Draft Statements')}
                                        className={userType.value === 'Draft Statements' ? 'active' : ''}
                                    >
                                        Draft Statements
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/imc-tax-payment', 'Final Statement')}
                                        className={userType.value === 'Final Statement' ? 'active' : ''}
                                    >
                                        Final Statement
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/client-tax-payment', 'Tax Payment and Filing')}
                                        className="activetab"
                                    >
                                        Tax Payment and Filing
                                    </li>
                                </ul>
                            ) : (
                                    ''
                                )}
                            {statusID === 21 && (usertype === 'EM' || usertype === 'Other employee users') ? (
                                <ul>
                                    <li
                                        onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}
                                        className={userType.value === 'L1 Checklist' ? 'active' : ''}
                                    >
                                        L1 Checklist
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')}
                                        className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}
                                    >
                                        L1 CRC Confirmed
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')}
                                        className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}
                                    >
                                        L1 AM Confirmed
                                    </li>
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')}
                                            className={userType.value === 'L2 Checklist' ? 'active' : ''}
                                        >
                                            L2 Checklist
                                        </li>
                                    ) : null}
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')}
                                            className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}
                                        >
                                            L2 CRC Confirmed
                                        </li>
                                    ) : null}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                    <li
                                        onClick={() => navigateChecklist('/menu/detail-analysis', 'Detailed Analysis')}
                                        className={userType.value === 'Detailed Analysis' ? 'active' : ''}
                                    >
                                        Detailed Analysis
                                    </li>
                                    {/* <li onClick={() => navigateChecklist(userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/client-draft-document', 'Draft Statements')} className={userType.value === 'Draft Statements' ? 'active' : ''}>Draft Statements</li> */}
                                    <li
                                        onClick={() => navigateChecklist('/menu/imc-draft-document', 'Draft Statements')}
                                        className={userType.value === 'Draft Statements' ? 'active' : ''}
                                    >
                                        Draft Statements
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/imc-tax-payment', 'Final Statement')}
                                        className={userType.value === 'Final Statement' ? 'active' : ''}
                                    >
                                        Final Statement
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/imc-final-doc-approval', 'Tax Payment and Filing')}
                                        className="activetab"
                                    >
                                        Tax Payment and Filing
                                    </li>
                                </ul>
                            ) : (
                                    ''
                                )}
                            {statusID === 22 && (usertype === 'EM' || usertype === 'Other employee users') ? (
                                <ul>
                                    <li
                                        onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}
                                        className={userType.value === 'L1 Checklist' ? 'active' : ''}
                                    >
                                        L1 Checklist
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')}
                                        className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}
                                    >
                                        L1 CRC Confirmed
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')}
                                        className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}
                                    >
                                        L1 AM Confirmed
                                    </li>
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')}
                                            className={userType.value === 'L2 Checklist' ? 'active' : ''}
                                        >
                                            L2 Checklist
                                        </li>
                                    ) : null}
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')}
                                            className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}
                                        >
                                            L2 CRC Confirmed
                                        </li>
                                    ) : null}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                    <li
                                        onClick={() =>
                                            navigateChecklist(
                                                userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/detail-analysis',
                                                'Detailed Analysis'
                                            )
                                        }
                                        className={userType.value === 'Detailed Analysis' ? 'active' : ''}
                                    >
                                        Detailed Analysis
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/client-draft-document', 'Draft Statements')}
                                        className={userType.value === 'Draft Statements' ? 'active' : ''}
                                    >
                                        Draft Statements
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/imc-tax-payment', 'Final Statement')}
                                        className={userType.value === 'Final Statement' ? 'active' : ''}
                                    >
                                        Final Statement
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/imc-final-doc-approval', 'Tax Payment and Filing')}
                                        className={userType.value === 'Tax Payment and Filing' ? 'active' : ''}
                                    >
                                        Tax Payment and Filing
                                    </li>
                                    <li onClick={() => navigateChecklist('/menu/imc-reports', 'Reports')} className="activetab">
                                        Reports
                                    </li>
                                </ul>
                            ) : (
                                    ''
                                )}
                            {statusID === 22 && usertype === 'Ultimate Client' ? (
                                <ul>
                                    <li
                                        onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}
                                        className={userType.value === 'L1 Checklist' ? 'active' : ''}
                                    >
                                        L1 Checklist
                                    </li>
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li> */}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li> */}
                                    {!userType.checklistFlag ? (
                                        <li
                                            onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')}
                                            className={userType.value === 'L2 Checklist' ? 'active' : ''}
                                        >
                                            L2 Checklist
                                        </li>
                                    ) : null}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> */}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                    {/* <li onClick={() => navigateChecklist('/menu/detail-analysis', 'Detailed Analysis')} className={userType.value === 'Detailed Analysis' ? 'active' : ''}>Detailed Analysis</li> */}
                                    {/* <li onClick={() => navigateChecklist('/menu/client-draft-document', 'Draft Statements')} className={userType.value === 'Draft Statements' ? 'active' : ''}>Draft Statements</li> */}
                                    <li
                                        onClick={() => navigateChecklist('/menu/imc-draft-document', 'Draft Statements')}
                                        className={userType.value === 'Draft Statements' ? 'active' : ''}
                                    >
                                        Draft Statements
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/imc-tax-payment', 'Final Statement')}
                                        className={userType.value === 'Final Statement' ? 'active' : ''}
                                    >
                                        Final Statement
                                    </li>
                                    <li
                                        onClick={() => navigateChecklist('/menu/client-final-doc-approval', 'Reports')}
                                        className="activetab"
                                    >
                                        Reports
                                    </li>
                                </ul>
                            ) : (
                                    ''
                                )}
                        </ul>
                    </div>
                </div>

                <Card className={classes.root}>
                    <CardContent className={classes.cardCustom}>
                        <CardHeader
                            className="borderBottomLine"
                            action={
                                <Button
                                    variant="outlined"
                                    className="btn-style"
                                    color="primary"
                                    onClick={addCard}
                                    disabled={usertype === 'Other employee users' || buttonDisable(stageId, userType.value)}
                                >
                                    Add Card
                                </Button>
                            }
                            title="Detailed Analysis"
                        // subheader={"Service No : " + serviceIdSelected.toString()}
                        />
                        <Typography className={classes.statement}>
                            <span style={{ color: '#f47a2c' }}>NOTE: </span>To avail services of Advith ITeC for detailed analysis, please
                            provide atleast one details and click on submit. In case you do not wish to avail ITeC service, disable the
                            selected card and click on draft statement to proceed further.
                        </Typography>
                        {/* <div>To avail services of Advith ITeC for detailed analysis , please provide atleast one details and click on submit.
In case you do not wish to avail ITeC service, disable the selected card and click on draft satement to proceed further</div> */}
                    </CardContent>
                    <CardContent>
                        <Paper>
                            {stageId >= 16 ? (
                                <div className="da-main-card">
                                    {dataList.map((d, index) => {
                                        return (
                                            <span>
                                                <Cardboxes
                                                    key={index}
                                                    data={d}
                                                    setRemarks={setRemarks}
                                                    setTitle={setTitle}
                                                    toggle={toggle}
                                                    deleteCard={deleteCard}
                                                    saveFile={saveFile}
                                                    handleRemoveClick={handleRemoveClick}
                                                />
                                            </span>
                                        );
                                    })}
                                </div>
                            ) : (
                                    <div className="da-main-card">
                                        {data.map((d, index) => {
                                            return (
                                                <span>
                                                    <Cardboxes
                                                        key={index}
                                                        data={d}
                                                        setRemarks={setRemarks}
                                                        setTitle={setTitle}
                                                        toggle={toggle}
                                                        deleteCard={deleteCard}
                                                        saveFile={saveFile}
                                                        handleRemoveClick={handleRemoveClick}
                                                    />
                                                </span>
                                            );
                                        })}
                                    </div>
                                )}
                        </Paper>
                    </CardContent>
                </Card>
                <div className="detailed-actions">
                    {showLoader ? (
                        <LoaderPopUp
                            showLoader={showLoader}
                            handleClose={handleClose}
                            title="Please wait while we submitting your Detailed Analysis"
                        />
                    ) : null}
                    {submitpop ? <SuccessPopUp open={submitpop} showSuccess={submitpop} title="Submitted Successfully" /> : null}
                    {successpop ? (
                        <SuccessPopUp open={successpop} showSuccess={successpop} title="Draft statement created successfully" />
                    ) : null}
                    {errorpop ? <ErrorPopUp open={errorpop} showError={errorpop} title={errorMsgGenerateRecceipt} /> : null}

                    <ul>
                        <li>
                            <Button
                                // disabled={usertype === "Other employee users"}
                                type="button"
                                color="primary"
                                variant="contained"
                                size="large"
                                onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')}
                                disabled={buttonDisable(stageId, userType.value)}
                            >
                                {' '}
                                Back{' '}
                            </Button>
                        </li>
                        <li>
                            <Button
                                //  usertype === 'EM' ? : toggleTrue
                                disabled={
                                    attachmentFlag
                                        ? 'disabled'
                                        : '' || (usertype === 'EM' && !data.attachmentsByCoreteam && !toggleTrue)
                                            ? 'disabled'
                                            : '' || usertype === 'Other employee users' || buttonDisable(stageId, userType.value)
                                }
                                type="submit"
                                color="primary"
                                variant="contained"
                                size="large"
                                onClick={submit}
                            >
                                {' '}
                                Submit{' '}
                            </Button>
                        </li>
                        <li>
                            <Button
                                type="submit"
                                color="primary"
                                variant="contained"
                                size="large"
                                onClick={() => {
                                    handleSubmitClickFordraftdoc();
                                }}
                                disabled={
                                    usertype === 'EM' && uploadedFiles
                                        ? 'disabled'
                                        : '' || usertype === 'Other employee users' || buttonDisable(stageId, userType.value) || !draftFlag
                                }
                            >
                                {' '}
                                Draft Statements{' '}
                            </Button>
                        </li>
                    </ul>
                </div>
            </Grid>
        </>
    );
};
export default DetailAnalysisCore;
